const EmiratesLogo = (props) => {
    return(<figure
      className="absolute top-0 z-50"
      id="logo"
      aria-label="Emirates Logo"
    >
      <img src={props.logoSm} width="" srcSet={`${props.logoSm} 300w, ${props.logo} 768w, ${props.logo} 1280w`} alt={props.alt || "Emirates Logo"} className='object-contain h-[68px] lg:h-[104px]' loading="lazy"/>
    </figure>);
}

export default EmiratesLogo;